// Plain words for the reference keys (table.column) the merge preview and the delete check answer
// (J/person/PersonReferences). A key without a label is shown as it is, so a new table still shows up.
const LABELS = {
  'accounts.person_id': ['personAdmin.ref.login', 'Login'],
  'event_editor.person_id': ['personAdmin.ref.programEditor', 'Program editor access'],
  'users.person_id': ['personAdmin.ref.legacyUsers', 'Records from the old registration system'],
  'speaker_profiles.person_id': ['personAdmin.ref.legacySpeaker', 'Records from the old speaker system'],
  'person_research_job.person_id': ['personAdmin.ref.research', 'AI research runs'],
  'person_change_set.person_id': ['personAdmin.ref.changeSets', 'Change history entries'],
  'program_entry.title_suggested_by_person_id': ['personAdmin.ref.titleSuggestions', 'Suggested talk titles'],
  'program_assignment.person_id': ['personAdmin.ref.spots', 'Program spots'],
  'invitation_email.person_id': ['personAdmin.ref.invitationEmails', 'Invitation emails sent'],
  'event_reminder_sent.person_id': ['personAdmin.ref.eventReminders', 'Event reminders sent'],
  'talk_deck_version.uploaded_by_person_id': ['personAdmin.ref.slideUploads', 'Slide uploads'],
  'program_entry.order_confirmed_by_person_id': ['personAdmin.ref.slideOrders', 'Confirmed slide orders'],
  'materials_audit_log.person_id': ['personAdmin.ref.slidesTrail', 'Slides consent and publication history'],
  'materials_reminder_sent.person_id': ['personAdmin.ref.slidesReminders', 'Slides reminders sent'],
  'event_body_member.person_id': ['personAdmin.ref.bodies', 'Memberships in organizers, committee or board'],
  'event_engagements.person_id': ['personAdmin.ref.registrations', 'Event registrations'],
  'person.merged_into_id': ['personAdmin.ref.mergedIn', 'Duplicates merged into this person earlier'],
  'speaker_invitations.person_id': ['personAdmin.ref.legacyInvitations', 'Invitations from the old system'],
  'converted_pending_account.person_id': ['personAdmin.ref.unusedLogins', 'Unused invitation logins from the old system'],
  'person_study_claim.person_id': ['personAdmin.ref.studies', 'Study decisions'],
  'person_public_profile.person_id': ['personAdmin.ref.publicProfile', 'Public profile setting'],
};

export const referenceLabel = (t, key) => {
  const label = LABELS[key];
  return label ? t(label[0], label[1]) : key;
};

// [{key, label, count}] of a {key: count} map, without the zero counts.
export const referenceRows = (t, counts) => Object.entries(counts || {})
  .filter(([, count]) => count > 0)
  .map(([key, count]) => ({ key, label: referenceLabel(t, key), count }));
